import type { TechnicalEnvironment } from '../types/content';

export const technicalEnvironments: TechnicalEnvironment[] = [
  { label: 'Enterprise IP Migration' },
  { label: 'Streaming Architectures' },
  { label: 'OTT/FAST Platforms' },
  { label: 'Global Distribution Networks' },
  { label: 'Hybrid Operating Models' }
];
